import {
  GroupedSizeFilterSection,
  GroupedSizeFilterSection_SizeRunCluster,
} from '@aboutyou/grpc-clients/tadarida/aysa_api/models/filter_section.types';
import {useEffect, useRef} from 'react';

/**
 * Gets all the available size filter's slug and store them in a ref.
 * The ref is used to keep in memory all the available slugs.
 * With this, even when the slugs are updated after the change of the other filters
 * we are able to reset them all.
 *
 * @return an array containing all the available slugs for the sizes filter
 */
export const useSizeFiltersSlugs = (
  sizeFilterSectionData: GroupedSizeFilterSection,
) => {
  const possibleSizeFilterSlugsRef = useRef(new Set<string>());
  const addSlugsTopossibleSizeFilterSlugsRef = (
    cluster: GroupedSizeFilterSection_SizeRunCluster | undefined,
  ) =>
    cluster?.sizeRuns.forEach(run =>
      possibleSizeFilterSlugsRef.current.add(run.slug),
    );

  useEffect(() => {
    if (sizeFilterSectionData.content?.$case === 'sizeRunClusters') {
      sizeFilterSectionData.content.sizeRunClusters.clusters.forEach(
        addSlugsTopossibleSizeFilterSlugsRef,
      );
    }

    if (sizeFilterSectionData.content?.$case === 'sizeTabs') {
      sizeFilterSectionData.content.sizeTabs.tabs.forEach(tab =>
        tab?.sizeRunClusters.clusters?.forEach(
          addSlugsTopossibleSizeFilterSlugsRef,
        ),
      );
    }
  }, [sizeFilterSectionData]);

  return Array.from(possibleSizeFilterSlugsRef.current.values());
};
